import ApiService from './ApiService.js'
import ApiHelper from './ApiHelper.js'

export default {
    search(value) {
        let header = ApiHelper.getHeader();
        return ApiService().get('api/organizations/search?name=' + encodeURI(value),
            { 
                headers: header
            });
    }
}